/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import { Icon, Link, Tooltip } from 'components';
import { SUPPORT_EMAIL } from 'utils/constants';

import FormContext from '../../FormContext';
import { StyledAlert } from '../../components';

const UnverifiedAlert = () => {
  const { isProfile, fetchedPrimaryNumberString } = useContext(FormContext);

  const bannerPrefix = isProfile ? 'You do' : 'This agent does';
  const tooltipTitle = `${isProfile ? 'Your' : "This agent's"} member ID ${
    fetchedPrimaryNumberString ? `(${fetchedPrimaryNumberString})` : ''
  } does not appear in your board data feeds. ${
    isProfile ? 'You' : 'This agent'
  } will have a limited experience on the platform until the discrepancy is resolved. Contact ${SUPPORT_EMAIL} if you have any questions.`;

  return (
    <StyledAlert
      message={
        <span>
          {bannerPrefix} not appear in your brokerage&apos;s data feeds. You may
          want to investigate further.{' '}
          <Tooltip title={tooltipTitle}>
            <Link>Why?</Link>
          </Tooltip>
        </span>
      }
      type="warning"
      showIcon
      icon={<Icon type="antdSwapOutlined" color="alertWarningIconColor" />}
    />
  );
};

export default UnverifiedAlert;
